import { render, staticRenderFns } from "./Channel.page.vue?vue&type=template&id=1aa2dc59&scoped=true&"
import script from "./Channel.page.vue?vue&type=script&lang=js&"
export * from "./Channel.page.vue?vue&type=script&lang=js&"
import style0 from "./Channel.page.vue?vue&type=style&index=0&id=1aa2dc59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa2dc59",
  null
  
)

export default component.exports